export default class ContactAttribute {
	constructor({
		name,
		type,
		slug,
		default: defaultAttribute,
		choices,
		archived,
		position
	} = {}) {
		this._name = name;
		this._type = type;
		this._slug = slug;
		this._defaultAttribute = defaultAttribute;
		this._choices = choices;
		this._archived = archived;
		this._position = position;
	}

	getKey = () => this._slug;

	getSlug = () => this._slug;

	getName = () => this._name;

	getType = () => this._type;

	getDefaultAttribute = () => this._defaultAttribute;

	getDefaultStringValue = () => String(this.getDefaultAttribute())

	getDefaultValue = () => this.getType() === 'bool' ? (this.getDefaultAttribute() === true ) : this.getDefaultAttribute();

	getChoices = () => this._choices || [];

	getArchived = () => this._archived;

	getPosition = () => this._position;

}